import React from 'react';

interface LogoProps {
  variant?: 'full' | 'icon';
  className?: string;
}

export default function Logo({ variant = 'full', className = '' }: LogoProps) {
  if (variant === 'icon') {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 120 120"
        fill="none"
        className={`w-10 h-10 ${className}`}
        aria-label="XamXamBoutik"
      >
        <defs>
          <linearGradient id="logoBg" x1="0" y1="0" x2="120" y2="120" gradientUnits="userSpaceOnUse">
            <stop offset="0%" stopColor="#FB923C" />
            <stop offset="100%" stopColor="#EA580C" />
          </linearGradient>
          <linearGradient id="logoShine" x1="0" y1="0" x2="120" y2="120" gradientUnits="userSpaceOnUse">
            <stop offset="0%" stopColor="#FFFFFF" stopOpacity={0.2} />
            <stop offset="50%" stopColor="#FFFFFF" stopOpacity={0} />
          </linearGradient>
        </defs>
        <rect width="120" height="120" rx="28" fill="url(#logoBg)" />
        <rect width="120" height="60" rx="28" fill="url(#logoShine)" />
        {/* Shopping bag handle */}
        <path d="M44 48 C44 28, 76 28, 76 48" stroke="white" strokeWidth="5" strokeLinecap="round" fill="none" />
        {/* Bag body */}
        <rect x="28" y="48" width="64" height="44" rx="8" fill="white" />
        {/* Ascending growth bars */}
        <rect x="38" y="74" width="12" height="14" rx="2.5" fill="#EA580C" />
        <rect x="54" y="66" width="12" height="22" rx="2.5" fill="#EA580C" />
        <rect x="70" y="58" width="12" height="30" rx="2.5" fill="#EA580C" />
      </svg>
    );
  }

  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 120 120"
        fill="none"
        className="w-8 h-8 sm:w-9 sm:h-9"
        aria-hidden="true"
      >
        <defs>
          <linearGradient id="logoBgFull" x1="0" y1="0" x2="120" y2="120" gradientUnits="userSpaceOnUse">
            <stop offset="0%" stopColor="#FB923C" />
            <stop offset="100%" stopColor="#EA580C" />
          </linearGradient>
          <linearGradient id="logoShineFull" x1="0" y1="0" x2="120" y2="120" gradientUnits="userSpaceOnUse">
            <stop offset="0%" stopColor="#FFFFFF" stopOpacity={0.2} />
            <stop offset="50%" stopColor="#FFFFFF" stopOpacity={0} />
          </linearGradient>
        </defs>
        <rect width="120" height="120" rx="28" fill="url(#logoBgFull)" />
        <rect width="120" height="60" rx="28" fill="url(#logoShineFull)" />
        {/* Shopping bag handle */}
        <path d="M44 48 C44 28, 76 28, 76 48" stroke="white" strokeWidth="5" strokeLinecap="round" fill="none" />
        {/* Bag body */}
        <rect x="28" y="48" width="64" height="44" rx="8" fill="white" />
        {/* Ascending growth bars */}
        <rect x="38" y="74" width="12" height="14" rx="2.5" fill="#EA580C" />
        <rect x="54" y="66" width="12" height="22" rx="2.5" fill="#EA580C" />
        <rect x="70" y="58" width="12" height="30" rx="2.5" fill="#EA580C" />
      </svg>
      <span className="text-xl lg:text-2xl font-extrabold tracking-tight" aria-label="XamXamBoutik">
        <span className="text-white">XamXam</span>
        <span className="text-primary">Boutik</span>
      </span>
    </div>
  );
}
